import { modal } from './modules/modal';
modal();

document.addEventListener('DOMContentLoaded', function () {
	const swiperThumb = new Swiper(".mySwiper-thumb", {
		spaceBetween: 20,
		slidesPerView: 1,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},

			breakpoints: {
				768: {
					spaceBetween: 60,
					slidesPerView: 1,
			},
		}
	});

	const swiperCont = new Swiper(".mySwiper-cont", {
		spaceBetween: 20,
		slidesPerView: 1,
		effect: "fade",
		speed: 0,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},

			breakpoints: {
				768: {
					spaceBetween: 60,
					slidesPerView: 1,
			},
		}
	});

	swiperCont.controller.control = swiperThumb;
	swiperThumb.controller.control = swiperCont;

});
